import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from './store';
import { prop } from 'ramda';

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export const useTimetableState = () => useAppSelector(prop('timetable'));
export const useTimetableManagerState = () =>
  useAppSelector(prop('timetableManager'));
